import * as React from "react";
import { NavMenuOption, PageLayout } from "components/PageLayout/PageLayout";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { ConfigurationTab } from "./tabs/ConfigurationTab/ConfigurationTab";
import { ApplicationsTab } from "./tabs/ApplcationsPage/ApplicationsTab";
import { useHistory, useParams } from "react-router-dom";
import { NotificationsTab } from "./tabs/NotificationsTab/NotificationsTab";
import { EmailProcessorSettingsTab } from "./tabs/EmailProcessorSettingsTab/EmailProcessorSettingsTab";
import { PagePath } from "../../types/PagePath";
import { LanguagesTab } from "./tabs/LanguagesPage/LanguagesTab";
import { AutoQuoteSettingsTab } from "./tabs/AutoQuoteSettingsTab/AutoQuoteSettingsTab";
import { BranchesTab } from "./tabs/BranchesTab/BranchesTab";
import { AppBundlesTab } from "./tabs/AppBundlesTab/AppBundlesTab";
import { AiPromptsTab } from "./tabs/AiPromptsTab/AiPromptsTab";
import { WebhooksTab } from "./tabs/WebhooksTab/WebhooksTab";

enum TabId {
  configuration = "configuration",
  applications = "applications",
  notifications = "notifications",
  webhooks = "webhooks",
  emailProcessorSettings = "emailProcessorSettings",
  languages = "languages",
  autoQuote = "autoQuote",
  branches = "branches",
  appBundles = "appBundles",
  aiPrompts = "aiPrompts"
}

const SystemSettingsPage: React.FC = () => {
  const { tabId = TabId.configuration } = useParams<{ tabId: string }>();
  const [selectedTabId, setSelectedTabId] = React.useState(tabId);
  const history = useHistory();

  return (
    <PageLayout title="System Settings" selectedNavMenu={NavMenuOption.SYSTEM_SETTINGS}>
      <Tabs
        variant="scrollable"
        value={selectedTabId || undefined}
        onChange={(event, value) => {
          setSelectedTabId(value);
          history.push(`${PagePath.systemSettings}/${value}`);
        }}
      >
        <Tab value={TabId.configuration} label="Configuration" />
        <Tab value={TabId.applications} label="Applications" />
        <Tab value={TabId.appBundles} label="App Bundles" />
        <Tab value={TabId.languages} label="Languages" />
        <Tab value={TabId.notifications} label="Notifications" />
        <Tab value={TabId.webhooks} label="Webhooks" />
        <Tab value={TabId.autoQuote} label="Auto-Quote Settings" />
        <Tab value={TabId.branches} label="Company Branches" />
        <Tab value={TabId.emailProcessorSettings} label="Email Processor Settings" />
        <Tab value={TabId.aiPrompts} label="AI Prompts" />
      </Tabs>
      {selectedTabId === TabId.configuration && <ConfigurationTab />}
      {selectedTabId === TabId.applications && <ApplicationsTab />}
      {selectedTabId === TabId.notifications && <NotificationsTab />}
      {selectedTabId === TabId.webhooks && <WebhooksTab />}
      {selectedTabId === TabId.emailProcessorSettings && <EmailProcessorSettingsTab />}
      {selectedTabId === TabId.languages && <LanguagesTab />}
      {selectedTabId === TabId.autoQuote && <AutoQuoteSettingsTab />}
      {selectedTabId === TabId.branches && <BranchesTab />}
      {selectedTabId === TabId.appBundles && <AppBundlesTab />}
      {selectedTabId === TabId.aiPrompts && <AiPromptsTab />}
    </PageLayout>
  );
};

export { SystemSettingsPage };
